import React from "react";
import Layout from "components/Layout";
import useTranslation from "translations/useTranslation";
import { HeadNormal, TextMedium } from "@tiendeo/react-components/dist/Typography";
import {
    FullPageWrapper,
    InfoWrapper,
    NotificationsMessage,
} from "./NotificationsManagementContainer.styles";

const NoResultsContainer = () => {
    const t = useTranslation();

    return (
        <Layout showSidebar={false}>
            <FullPageWrapper>
                <InfoWrapper>
                    <HeadNormal>{t("NOTIFICATIONS")}</HeadNormal>
                    <NotificationsMessage>
                        <TextMedium>{t("GENERIC_ERROR_MESSAGE")}</TextMedium>
                    </NotificationsMessage>
                </InfoWrapper>
            </FullPageWrapper>
        </Layout>
    );
};

export default NoResultsContainer;
